import { ExperimentMetric } from 'src/services';

export const experimentMetricTranslations = {
  [ExperimentMetric.AverageOrderValue]: 'Average Order Value',
  [ExperimentMetric.AverageRevenuePerUser]: 'Average Revenue Per User',
  [ExperimentMetric.UserConversion]: 'User Conversion Rate',
};
